import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { Gtm } from '../gtm.event';
import './gtm-event-custom';

@Injectable({
    providedIn: 'root'
})
export class GtmEventCustomTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfGtmCustomEvent') {
                this.dispatch(event, event.data);
            }
        });
    }

    /**
     * Dispatch event
     */
    dispatch(trigger: DfEventData, customEvent: Gtm.CustomEvent<any>) {
        return this.gtmService.dispatch({
            event: 'custom_event',
            triggerContext: {
                trigger
            },
            event_name: customEvent.name,
            event_data: customEvent.data
        });
    }
}
